<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-items-center">
    <div
      class="tw-w-full tw-max-w-lg"
      :class="isIntro ? 'tw-text-left' : 'tw-text-center'"
    >
      <h2
        v-if="question.title"
        class="question-title-v2 tw-mb-3"
      >
        {{ question.title }}
      </h2>

      <p
        v-if="question.question"
        class="tw-mb-6 tw-text-onyx"
      >
        {{ question.question }}
      </p>

      <div
        v-if="answerList.length"
        class="tw-flex tw-justify-center"
      >
        <button
          type="button"
          :class="ctaClass"
          :disabled="disabled"
          @click="$emit('choose', answerList[0])"
        >
          {{ answerList[0].name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * CTA sub-layout of the `single` follow-up: intro / notice screens with a
 * single primary action. Presentational — no selection is tracked; clicking
 * the button emits `choose` with the sole answer.
 */
const CTA_CLASS =
  'tw-rounded-lg tw-bg-lavender-purple tw-px-12 tw-py-3 tw-font-atten-bold tw-uppercase tw-tracking-widest tw-text-white disabled:tw-opacity-60';

export default {
  name: 'FollowupV7SingleCta',

  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ctaClass: CTA_CLASS,
    };
  },

  computed: {
    answerList() {
      return this.question.answerlist || [];
    },
    isIntro() {
      // Intro screens carry both a heading and a body paragraph (left-aligned);
      // notice screens (e.g. dosage info) carry only a title (centered).
      return Boolean(this.question.title) && Boolean(this.question.question);
    },
  },
};
</script>
